var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "box-card", attrs: { shadow: "hover" } },
    [
      _c(
        "div",
        { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
        [_c("span", [_vm._v("流程信息")])]
      ),
      _vm.historicTaskMap.size
        ? _c(
            "el-timeline",
            { attrs: { reverse: true } },
            _vm._l(_vm.historicTaskMap, function (arra, index) {
              return _c(
                "el-timeline-item",
                {
                  key: index,
                  attrs: {
                    color: "#3f9eff",
                    timestamp: _vm
                      .moment(arra[1][0].histIns.endTime)
                      .format("YYYY-MM-DD"),
                    placement: "top",
                  },
                },
                [
                  _c(
                    "el-card",
                    { staticClass: "flow" },
                    [
                      _c("h4", [
                        _vm._v(_vm._s(arra[1][0].histIns.activityName)),
                      ]),
                      _c(
                        "el-row",
                        { attrs: { gutter: 25 } },
                        [
                          _vm._l(arra[1], function (act, index) {
                            return [
                              _c(
                                "el-col",
                                {
                                  key: index,
                                  staticClass: "tip",
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: { span: 11 },
                                },
                                [
                                  _c("div", { staticClass: "item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("审批人 : "),
                                    ]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(_vm._s(act.assigneeName)),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("办理状态 : "),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "value" },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: act.comment.level,
                                              effect: "dark",
                                              size: "small",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(act.comment.status) + " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "item" },
                                    [
                                      _c("span", { staticClass: "label" }, [
                                        _vm._v("审批意见 : "),
                                      ]),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: act.comment.message,
                                            placement: "top-start",
                                          },
                                        },
                                        [
                                          _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(act.comment.message) +
                                                " "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("开始时间 : "),
                                    ]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(act.histIns.startTime) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("结束时间 : "),
                                    ]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        " " + _vm._s(act.histIns.endTime) + " "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("用时 : "),
                                    ]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(_vm._s(act.durationTime || "0秒")),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }